<template>
    <app-dialog :title="$t('dialogs.chooseOption')" v-bind="$attrs" :isAlertDialog="true" @input="onDialogInput">
        <template v-slot:content>
            <div class="pt-12 px-3 py-3 font-size-lg dark-red-color" data-cy="app-dialog-alert-text" v-html="tHtml(html)"></div>
        </template>

        <template v-slot:buttons="{}">
            <div v-for="format in formats" :key="format.extension">
                <v-btn text class="myprovet-btn-ok" @click="$emit('input', $event)"> {{ format.name }} </v-btn>
            </div>
        </template>
    </app-dialog>
</template>

<script>
export default {
    props: {
        formats: Array,
    },

    data() {
        return {};
    },

    created() {},

    watch: {},

    methods: {
        onCloseDialog() {
            this.$emit('on-cancel', false);
        },
    },
};
</script>
